export const LOCATION_LABELS = {
  STORE_CLEAN: "Store Clean",
  ROOM_CLEAN: "Room Clean/In Use",
  DIRTY_CHECKOUT: "Dirty in Checkout Room",
  DIRTY_HOLDING: "Dirty Holding",
  EXTERNAL_LAUNDRY: "At External Laundry",
  RETURNED_AWAITING: "Returned Awaiting Storage",
  DAMAGED_QUARANTINE: "Damaged/Quarantine",
  LOST_DISPOSED: "Lost/Disposed",
  SOURCE_EXTERNAL: "External Source",
};

export const ACCOUNTABLE_LOCATIONS = [
  "STORE_CLEAN", "ROOM_CLEAN", "DIRTY_CHECKOUT", "DIRTY_HOLDING",
  "EXTERNAL_LAUNDRY", "RETURNED_AWAITING", "DAMAGED_QUARANTINE",
];

export const ROOM_STATUSES = [
  "Vacant Clean", "Occupied", "Checkout Expected",
  "Checked Out/Dirty", "Cleaning in Progress", "Ready",
];

export const TXN_TYPE_LABELS = {
  opening_stock: "Opening Stock",
  opening_allocation: "Opening Allocation",
  purchase_receipt: "Purchase Receipt",
  hk_place_in_room: "Placed in Room",
  hk_remove_from_room: "Removed from Room",
  hk_found_dirty: "Found Dirty",
  hk_report_damage: "Damage Reported",
  room_issue: "Room Issue",
  checkout_count: "Checkout Count",
  dirty_collect: "Dirty Collection",
  laundry_dispatch: "Laundry Dispatch",
  laundry_receive: "Laundry Receive",
  laundry_rejected: "Rejected on Return",
  return_to_store: "Return to Store",
  return_to_room: "Return to Room",
  damage_report: "Damage Report",
  disposal: "Disposal",
  approved_loss: "Approved Loss",
  adjustment_positive: "Adjustment (Add)",
  adjustment_negative: "Adjustment (Deduct)",
  correction_reversal: "Correction Reversal",
  correction_replacement: "Correction Replacement",
};

export const fmtNum = (n) => (n === undefined || n === null ? "—" : Number(n).toLocaleString());
export const fmtDate = (s) => (s ? new Date(s).toLocaleString(undefined, { year: "numeric", month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" }) : "—");
export const todayISO = () => new Date().toISOString().slice(0, 10);
